import * as React from 'react';
import { Switch, Form } from 'antd';
const FormItem = Form.Item;

/*
* BooleanViewProps
*/
interface BooleanViewProps {
	mode: ControlMode;
	label?: string;
	value: boolean;
	required?: boolean;
	onChanged?: (newValue: boolean) => void;
	size?: 'small';
}

/**
 * BooleanView class
 */
export class BooleanView extends React.Component<BooleanViewProps, { value: boolean }> {
	public state = {
		value: this.props.value
	};

	public componentWillReceiveProps(nextProps: Readonly<BooleanViewProps>, nextContext: any) {
		if (nextProps.value != this.state.value) {
			this.setState({
				value: nextProps.value
			});
		}
	}

	/**
	 * Render
	 */
	public render() {
		const { label, mode, onChanged, required, size } = this.props;

		return (
			<FormItem label={label}
				required={required}
			>
				<Switch checked={this.state.value}
					onChange={this.onChanged}
					disabled={mode == 'display'}
					size={size}
				/>
			</FormItem>
		);
	}

	/**
	 * On change value
	 * @param newVal
	 */
	protected onChanged = (newVal: boolean) => {
		this.props.onChanged(newVal);
		this.setState({
			value: newVal,
		});
	}
}



// WEBPACK FOOTER //
// ./src/core/ui/boolean.view.tsx